<div
  class='top-bar w-100 text-right d-flex align-middle flex-column justify-content-between pl-4 pr-3'
>
  <div class='navigation pl-md'>
    <a routerLink="/" *ngIf='currentUser' class='logo'
    >
      <img
        [src]="
                currentUser.logo
                  ? currentUser.logo
                  : '/assets/logo/VZP-REACH-small.png'
              "
      /></a>
    <h5 class='m-0 text-white'>
      {{
      (currentUser && currentUser.header)
        ? currentUser.header
        : 'VZP Reach'
      }}
    </h5>

    <app-navigation class='menu'></app-navigation>
  </div>
</div>
<div
  class='container-fluid secondary-nav-container'
  [class.has-back]='canGoBack'
>
  <div
    class='columns'
    *ngIf='nav && nav.length'
    (mouseleave)='onNavMouseLeave()'
    (mouseenter)='onNavMouseEnter()'
  ></div>
</div>


